/* =========================================================
   The Dead Bedroom Playbook — behavior
   Vanilla port of the landing page logic. Runs on load.
   Selectors/IDs/classes match the markup exactly.
   ========================================================= */
(function () {
  /* =========================================================
     AFFILIATE CHECKOUT ROUTING
     The destination of every purchase button is chosen by the
     ?affiliate= value in the URL. Add rows to AFFILIATES to give
     each affiliate their own checkout link. Anything not listed
     (or no ?affiliate= at all) falls back to DEFAULT_CHECKOUT.
     Example: ...?affiliate=jake  ->  uses AFFILIATES.jake
     ========================================================= */
  var DEFAULT_CHECKOUT = 'https://www.seduction-lab.com/cart/58446208041347:1';
  var AFFILIATES = {
    // 'affiliateName': 'https://www.seduction-lab.com/cart/58446208041347:1?ref=affiliateName',
    // 'jake':  'https://www.seduction-lab.com/cart/58446208041347:1?ref=jake',
    // 'chris': 'https://www.seduction-lab.com/cart/58446208041347:1?ref=chris'
  };

  function resolveCheckout() {
    var key = '';
    try {
      key = (new URLSearchParams(window.location.search).get('affiliate') || '').trim().toLowerCase();
    } catch (e) {
      var m = window.location.search.match(/[?&]affiliate=([^&]+)/i);
      key = m ? decodeURIComponent(m[1]).trim().toLowerCase() : '';
    }
    if (key && Object.prototype.hasOwnProperty.call(AFFILIATES, key)) return AFFILIATES[key];
    return DEFAULT_CHECKOUT;
  }

  function applyCheckout(root) {
    var url = resolveCheckout();
    // Every real purchase link points at the seduction-lab cart. Redirect them
    // all to the resolved (affiliate-aware) checkout, and open in a new tab.
    var links = Array.prototype.slice.call(root.querySelectorAll('a[href*="seduction-lab.com/cart"], a[data-checkout]'));
    links.forEach(function (a) {
      a.setAttribute('href', url);
      a.setAttribute('target', '_blank');
      a.setAttribute('rel', 'noopener');
    });
  }

  function init() {
    var root = document;

    applyCheckout(root);

    /* --- Rotating hero word --- */
    var rotor = root.getElementById('dbp-rotor');
    if (rotor) {
      var words = ['waiting', 'begging', 'guessing', 'pretending', 'settling'];
      var wi = 0;
      rotor.style.transition = 'opacity .3s ease, transform .3s ease';
      setInterval(function () {
        rotor.style.opacity = '0';
        rotor.style.transform = 'translateY(-6px)';
        setTimeout(function () {
          wi = (wi + 1) % words.length;
          rotor.textContent = words[wi];
          rotor.style.opacity = '1';
          rotor.style.transform = 'translateY(0)';
        }, 300);
      }, 2200);
    }

    /* --- Scroll reveal --- */
    var reveals = Array.prototype.slice.call(root.querySelectorAll('[data-reveal]'));
    reveals.forEach(function (el) {
      el.style.opacity = '0';
      el.style.transform = 'translateY(26px)';
      el.style.transition = 'opacity .7s cubic-bezier(.2,.8,.2,1), transform .7s cubic-bezier(.2,.8,.2,1)';
    });
    if ('IntersectionObserver' in window) {
      var ro = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          if (e.isIntersecting) { e.target.style.opacity = '1'; e.target.style.transform = 'translateY(0)'; ro.unobserve(e.target); }
        });
      }, { threshold: 0.12 });
      reveals.forEach(function (el) { ro.observe(el); });
    } else {
      reveals.forEach(function (el) { el.style.opacity = '1'; el.style.transform = 'none'; });
    }

    /* --- Count-up stats --- */
    var counters = Array.prototype.slice.call(root.querySelectorAll('[data-count]'));
    var runCount = function (el) {
      var target = parseFloat(el.getAttribute('data-count'));
      var decimals = parseInt(el.getAttribute('data-decimals') || '0', 10);
      var suffix = el.getAttribute('data-suffix') || '';
      var dur = 1400, start = performance.now();
      var step = function (now) {
        var p = Math.min((now - start) / dur, 1);
        var eased = 1 - Math.pow(1 - p, 3);
        var val = target * eased;
        el.textContent = (decimals ? val.toFixed(decimals) : Math.round(val)) + suffix;
        if (p < 1) requestAnimationFrame(step);
        else el.textContent = (decimals ? target.toFixed(decimals) : Math.round(target)) + suffix;
      };
      requestAnimationFrame(step);
    };
    if ('IntersectionObserver' in window) {
      var co = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) { if (e.isIntersecting) { runCount(e.target); co.unobserve(e.target); } });
      }, { threshold: 0.6 });
      counters.forEach(function (el) { co.observe(el); });
    }

    /* --- Nav solidify on scroll --- */
    var nav = root.getElementById('dbp-nav');
    var onScroll = function () {
      if (!nav) return;
      if (window.scrollY > 40) {
        nav.style.background = 'rgba(11,11,11,0.92)';
        nav.style.borderBottomColor = 'rgba(255,255,255,0.08)';
        nav.style.backdropFilter = 'blur(10px)';
        nav.style.webkitBackdropFilter = 'blur(10px)';
        nav.style.paddingTop = '11px';
        nav.style.paddingBottom = '11px';
      } else {
        nav.style.background = 'rgba(13,13,13,0)';
        nav.style.borderBottomColor = 'rgba(255,255,255,0)';
        nav.style.backdropFilter = 'blur(0px)';
        nav.style.webkitBackdropFilter = 'blur(0px)';
        nav.style.paddingTop = '16px';
        nav.style.paddingBottom = '16px';
      }
    };
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();

    /* --- Sticky bottom bar (show once hero is scrolled past) --- */
    var sticky = root.getElementById('dbp-sticky');
    var hero = root.getElementById('dbp-hero');
    if (sticky && hero && 'IntersectionObserver' in window) {
      var so = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) { sticky.style.transform = e.isIntersecting ? 'translateY(120%)' : 'translateY(0)'; });
      }, { threshold: 0 });
      so.observe(hero);
    }

    /* --- FAQ accordion --- */
    var faqs = Array.prototype.slice.call(root.querySelectorAll('.dbp-faq'));
    faqs.forEach(function (item) {
      var btn = item.querySelector('.dbp-faq-q');
      var ans = item.querySelector('.dbp-faq-a');
      var icon = item.querySelector('.dbp-faq-i');
      btn.addEventListener('click', function () {
        var open = ans.style.maxHeight && ans.style.maxHeight !== '0px';
        faqs.forEach(function (other) {
          other.querySelector('.dbp-faq-a').style.maxHeight = '0px';
          other.querySelector('.dbp-faq-i').style.transform = 'rotate(0deg)';
          other.style.borderColor = 'rgba(255,255,255,0.08)';
        });
        if (!open) {
          ans.style.maxHeight = ans.scrollHeight + 'px';
          icon.style.transform = 'rotate(45deg)';
          item.style.borderColor = 'rgba(201,75,44,0.5)';
        }
      });
    });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();